<script lang="ts">
	//UI
	import { AdaptiveTextInput } from "@hitit/new_ui";
	//Utils
	//Types
	//Props
	export let title = "";
	export let value = "";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="link-box">
	<span class="link-title"> {title} </span>
	<div class="link-input">
		<AdaptiveTextInput bind:value backgroundColor={'#f0f0f4'} />
	</div>
</div>

<style lang="scss">
	.link-box {
		display: flex;
		flex-direction: column;
		gap: 10px;
		.link-title {
			text-align: left;
			font-weight: 200;
			color: #6d6f76;
			font-size: 1rem;
		}

		.link-input {
			height: 40px;
			width: 100%;
			color: #46474b;
			font-weight: 300;
		}
	}

</style>
